import _ from "lodash";
import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { CHAT_SCREEN_MODE } from "MessagingV2/modules/Utils";

const ChatOptionsContext = createContext({});

// activeUserId: it refers to userId of the user whose context is being used to open chat
// for normal mode it will be the userId of the user who is logged in
// for view mode it will be the userId of the user whose chat is being viewed
const ChatOptionsProvider = props => {
  const {
    children,
    chatId,
    screenMode,
    activeUserId,
    isPreviewMessagesModal,
  } = props;

  const value = useMemo(
    () => ({
      chatId,
      screenMode,
      activeUserId,
      isPreviewMessagesModal,
    }),
    [chatId, screenMode, activeUserId, isPreviewMessagesModal]
  );

  return (
    <ChatOptionsContext.Provider value={value}>
      {children}
    </ChatOptionsContext.Provider>
  );
};

ChatOptionsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  chatId: PropTypes.string,
  isPreviewMessagesModal: PropTypes.bool,
  screenMode: PropTypes.oneOf(_.values(CHAT_SCREEN_MODE)).isRequired,
};

ChatOptionsProvider.defaultProps = {
  isPreviewMessagesModal: false,
  chatId: null,
};

const useChatOptions = () => {
  const context = useContext(ChatOptionsContext);
  return context;
};

const withChatOptions = ({ selector = state => state } = {}) => Component => {
  const WithChatOptions = props => {
    const chatOptions = useChatOptions();
    const valuesToBePassed = selector(chatOptions);

    return <Component {...props} {...valuesToBePassed} />;
  };

  return WithChatOptions;
};

export { useChatOptions, withChatOptions };
export default ChatOptionsProvider;
